import { join } from 'node:path';
import { rm } from 'node:fs/promises';
import { temporaryDirectory } from 'tempy';
import isGitUrl from 'is-git-url';
import { pathExists } from '@wix/cli-fs';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { gitClone } from '@wix/package-manager';

async function downloadAndExtractRepo(url: string) {
  const repoDir = temporaryDirectory({ prefix: 'wix-create-app' });

  try {
    await gitClone(url, repoDir);
    await rm(join(repoDir, '.git'), { recursive: true, force: true });

    return repoDir;
  } catch (e) {
    throw new CliError({
      code: CliErrorCode.FailedToCloneRepo(),
      cause: e,
    });
  }
}

export async function fetchTemplate(url: string, path = '.') {
  if (!isGitUrl(url)) {
    throw new CliError({
      code: CliErrorCode.InvalidGitUrl({ url }),
      info: { url },
      cause: null,
    });
  }

  const repoDir = await downloadAndExtractRepo(url);
  const templateDirInRepo = join(repoDir, path);

  if (!(await pathExists(templateDirInRepo))) {
    throw new CliError({
      code: CliErrorCode.TemplatePathNotFound({ templatePath: path }),
      info: { templatePath: path },
      cause: null,
    });
  }

  return templateDirInRepo;
}
